import React from 'react';
import {View, TouchableOpacity, Image, StyleSheet} from 'react-native';
import Divider from './menuDivider';
import {FontAwesome} from '@expo/vector-icons';
import {MaterialCommunityIcons} from '@expo/vector-icons';
import CustomScrollBar from '../../commons/customScrollBar';
import {TeamCollapsedItems} from './teamMenu';
import ExIcon from '../../../assets/G_Ex_icon.png';

const iconStyle = {fontSize: '24px', color: '#768ea5'};

const CollapsedItem = ({testID, onPress, popInternet, children, style}) => (
  <TouchableOpacity
    testID={testID}
    onPress={() => {
      popInternet === true && onPress();
    }}
    style={[styles.item, style]}>
    {children}
  </TouchableOpacity>
);

export const CollapsedMenu = ({
  popInternet,
  team,
  initial,
  activeRoute,
  showPPMTest,
  scanEntryRoute,
  onExpand,
  onNavigate,
  onSupport,
  onReportBug,
  onLogout
}) => {
  return (
    <React.Fragment>
      <TouchableOpacity
        testID="expandMenu"
        onPress={onExpand}
        style={styles.expandButton}>
        <MaterialCommunityIcons
          name="chevron-double-right"
          size={26}
          style={styles.vectorIcon}
        />
      </TouchableOpacity>
      <CustomScrollBar contentContainerStyle={styles.scrollContent}>
        {team ? (
          <TeamCollapsedItems
            initial={initial}
            activeRoute={activeRoute}
            onNavigate={route => popInternet === true && onNavigate(route)}
            onReportBug={() => popInternet === true && onReportBug()}
            onLogout={() => popInternet === true && onLogout()}
          />
        ) : (
          <View style={styles.itemsContainer}>
            <Divider marginTop={20} />
            <CollapsedItem
              testID="redirectToScanPack"
              popInternet={popInternet}
              onPress={() => onNavigate(scanEntryRoute)}>
              <i className="icon-scanner-icon" style={iconStyle}></i>
            </CollapsedItem>
            <CollapsedItem
              testID="allOrders"
              popInternet={popInternet}
              onPress={() => onNavigate('Orders')}>
              <MaterialCommunityIcons
                name="note-text"
                size={22}
                style={styles.vectorIcon}
              />
            </CollapsedItem>
            <CollapsedItem
              testID="redirectToProductSearchGrid"
              popInternet={popInternet}
              onPress={() => onNavigate('ProductSearchGrid')}>
              <FontAwesome name="tags" size={22} style={styles.vectorIcon} />
            </CollapsedItem>
            <CollapsedItem
              testID="redirectToScanReceive"
              popInternet={popInternet}
              onPress={() => onNavigate('InventoryReport', {mode: 'receive'})}>
              <i className="icon-receive" style={iconStyle}></i>
            </CollapsedItem>
            <CollapsedItem
              testID="redirectToScanRecount"
              popInternet={popInternet}
              onPress={() => onNavigate('InventoryReport', {mode: 'recount'})}>
              <i className="icon-recount" style={iconStyle}></i>
            </CollapsedItem>
            <CollapsedItem
              testID="redirectToPrint"
              popInternet={popInternet}
              onPress={() => onNavigate('PrintJob')}>
              <i className="icon-print" style={iconStyle}></i>
            </CollapsedItem>
            <Divider marginTop={25} />
            <CollapsedItem
              testID="settingpage"
              popInternet={popInternet}
              onPress={() => onNavigate('Settings')}>
              <i className="icon-cog" style={iconStyle}></i>
            </CollapsedItem>
            <CollapsedItem
              testID="statisticsPage"
              popInternet={popInternet}
              onPress={() => onNavigate('Dashboard')}>
              <Image
                source={require('../../../assets/bar-chart.png')}
                style={styles.statisticsIcon}
              />
            </CollapsedItem>
            {showPPMTest && (
              <CollapsedItem
                testID="ppmTestPage"
                popInternet={popInternet}
                onPress={() => onNavigate('PPMTestDataGenerator')}>
                <MaterialCommunityIcons
                  name="test-tube"
                  size={22}
                  style={styles.vectorIcon}
                />
              </CollapsedItem>
            )}
            <CollapsedItem
              testID="setFeedbackPopup"
              popInternet={popInternet}
              onPress={onSupport}>
              <i className="icon-lifebuoy" style={iconStyle}></i>
            </CollapsedItem>
            <CollapsedItem
              testID="reportBug"
              popInternet={popInternet}
              onPress={onReportBug}>
              <i className="icon-bug" style={iconStyle}></i>
            </CollapsedItem>
            <CollapsedItem
              testID="logout"
              popInternet={popInternet}
              onPress={onLogout}
              style={styles.logoutItem}>
              <i
                className="icon-logout"
                style={{...iconStyle, transform: 'rotate(180deg)'}}></i>
            </CollapsedItem>
          </View>
        )}
        <View style={styles.brandContainer}>
          <View style={styles.brandIcon}>
            <Image
              source={ExIcon}
              style={styles.fullSize}
              resizeMode="contain"
            />
          </View>
        </View>
      </CustomScrollBar>
    </React.Fragment>
  );
};

const styles = StyleSheet.create({
  expandButton: {
    width: '100%',
    height: 30,
    justifyContent: 'center',
    alignItems: 'center'
  },
  scrollContent: {
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: '100%'
  },
  itemsContainer: {
    marginBottom: '3rem'
  },
  item: {
    marginTop: 20,
    width: '100%',
    height: 30,
    justifyContent: 'center',
    alignItems: 'center'
  },
  logoutItem: {
    marginTop: 30
  },
  vectorIcon: {
    color: '#768ea5'
  },
  statisticsIcon: {
    width: 22,
    height: 22,
    resizeMode: 'contain',
    tintColor: '#7790A5'
  },
  brandContainer: {
    alignItems: 'center',
    marginBottom: 10
  },
  brandIcon: {
    width: 40,
    height: 40
  },
  fullSize: {
    width: '100%',
    height: '100%'
  }
});

export default CollapsedMenu;
